import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-activities',
  templateUrl: './4ir.component.html',
  styleUrls: ['./4ir.component.css']
})
export class ActivitiesComponent implements OnInit {

  step = -1;

  setStep(index: number) {
    this.step = index;
  }

  nextStep() {
    this.step++;
  }

  prevStep() {
    this.step--;
  }
  
  constructor() { }

  ngOnInit() {
  }

}
